import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getUserSummaryClientBill(payload) {
    const result = await axios.post(apiUrl + "/admin/summary/clientbill",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getUserSummaryMasterBill(payload) {
    const result = await axios.post(apiUrl + "/admin/summary/masterbill",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function getValanBill(payload) {
    const result = await axios.post(apiUrl + "/valan/get/valanbill",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

export const UserSummaryService = {
    getUserSummaryClientBill,
    getUserSummaryMasterBill,
    getValanBill
}